// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `friend/index${i + 1}`,
  name: `friendIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/friend/index${i + 1}.vue`)
}))

const BranchRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `friend/branch/index${i + 1}`,
  name: `friendBranchIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/friend/branch/index${i + 1}.vue`)
}))


export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,
    ...BranchRoutes,
 

  ],
};
